import React from 'react';
import { FaEye, FaCheck, FaUserTimes, FaPen, FaTrash, FaCamera } from 'react-icons/fa';
import ContextMenu from '@/components/common/ContextMenu';
import { ESTADOS_CITAS } from '@/constants/estados';
import moment from 'moment';

/**
 * Menú contextual para acciones de citas
 */
const AppointmentContextMenu = ({
  cita,
  isAdmin,
  isSuperAdmin,
  clienteData,
  hasMaintenanceToView,
  onViewMaintenance,
  onFinalizeMaintenance,
  onMarkNoShow,
  onEdit,
  onDelete,
  onFotosAntes
}) => {
  // Verificar si la cita ya pasó
  const citaDateTime = moment(cita.Fecha + ' ' + cita.Hora, 'YYYY-MM-DD HH:mm');
  const isPast = citaDateTime.isBefore(moment());
  
  // Verificar permisos
  const canEdit = isAdmin || isSuperAdmin || 
    (clienteData && cita.ClienteID && cita.ClienteID === clienteData.id);
  
  const canShowAdminActions = (isAdmin || isSuperAdmin) && !cita.finalizada;
  const canShowEditActions = canEdit && (!isPast || (isAdmin || isSuperAdmin));

  const menuItems = [];

  // Ver detalle del mantenimiento (para citas completadas)
  if (hasMaintenanceToView) {
    menuItems.push({
      label: 'Ver Mantenimiento',
      icon: <FaEye size={14} />,
      iconColor: 'text-blue-400',
      onClick: onViewMaintenance,
      title: 'Ver detalle del mantenimiento realizado'
    });
  }

  // Fotos Estado Previo (solo admins, citas no finalizadas)
  if (canShowAdminActions && onFotosAntes) {
    if (menuItems.length > 0) {
      menuItems.push({ separator: true });
    }
    
    menuItems.push({
      label: 'Cargar fotos previas',
      icon: <FaCamera size={14} />,
      iconColor: 'text-blue-400',
      onClick: onFotosAntes,
      title: 'Capturar fotos del estado inicial del vehículo'
    });
  }

  // Finalizar mantenimiento (solo admins, citas no finalizadas)
  if (canShowAdminActions) {
    if (menuItems.length > 0) {
      menuItems.push({ separator: true });
    }
    
    menuItems.push({
      label: 'Finalizar Mantenimiento',
      icon: <FaCheck size={14} />,
      iconColor: 'text-green-400',
      onClick: onFinalizeMaintenance,
      title: 'Finalizar y crear registro de mantenimiento'
    });
  }

  // Marcar como "No Asistió" (solo admins, citas pasadas pendientes)
  if ((isAdmin || isSuperAdmin) && isPast && !cita.finalizada && 
      cita.Estado !== ESTADOS_CITAS.NO_ASISTIO.nombre && 
      cita.Estado !== ESTADOS_CITAS.COMPLETADA.nombre && 
      cita.Estado !== ESTADOS_CITAS.CANCELADA.nombre) {
    
    if (menuItems.length > 0) {
      menuItems.push({ separator: true });
    }
    
    menuItems.push({
      label: 'Cliente no asistió',
      icon: <FaUserTimes size={14} />,
      iconColor: 'text-gray-400',
      onClick: onMarkNoShow,
      title: 'Marcar que el cliente no se presentó'
    });
  }

  // Acciones de edición
  if (canShowEditActions) {
    if (menuItems.length > 0) {
      menuItems.push({ separator: true });
    }
    
    menuItems.push({
      label: 'Editar Cita',
      icon: <FaPen size={14} />,
      iconColor: 'text-yellow-400',
      onClick: onEdit,
      title: 'Editar información de la cita'
    });

    if (onDelete) {
      menuItems.push({
        label: 'Eliminar Cita',
        icon: <FaTrash size={14} />,
        iconColor: 'text-red-400',
        textColor: 'text-red-400',
        onClick: onDelete,
        title: 'Eliminar la cita permanentemente'
      });
    }
  }

  // Si no hay acciones disponibles, no mostrar el menú
  if (menuItems.length === 0) {
    return null;
  }

  return (
    <ContextMenu 
      items={menuItems}
      triggerClassName="h-full px-3 bg-gray-700 hover:bg-gray-600 border border-gray-600 rounded transition-colors text-gray-400 hover:text-white flex items-center justify-center"
    />
  );
};

export default AppointmentContextMenu;